import { Button, Col, Row, Result, notification } from "antd";
import { useState } from "react";
import { getLoginUserDetailsApi, logOutApi, resendVerificationEmailApi } from "../../config/Api";
import { apiErrorMessage } from "../../services/ApiError";
import { setStoredUserVerified, storedUserEmail } from "../../services/EmailVerified";
import { logOut } from "../../services/LogOut";
import "./style/ForgetPassword.scss";

// shown instead of the app to a logged-in user whose email isn't verified yet
export const VerifyEmailNotice = () => {
    const [sending, setSending] = useState(false)
    const [checking, setChecking] = useState(false)
    const email = storedUserEmail()

    const resend = () => {
        setSending(true)
        resendVerificationEmailApi()
            .then((res) => notification.success({ message: res.data.message }))
            .catch((err) => notification.error({ message: apiErrorMessage(err) }))
            .finally(() => setSending(false))
    }

    // after clicking the link in another tab or device
    const checkAgain = () => {
        setChecking(true)
        getLoginUserDetailsApi()
            .then((res) => {
                if (res.data?.user?.is_email_verified) {
                    setStoredUserVerified(true)
                    window.location.assign('/')
                } else {
                    notification.warning({ message: 'Your email is not verified yet. Please click the link in the email.' })
                }
            })
            .catch((err) => notification.error({ message: apiErrorMessage(err) }))
            .finally(() => setChecking(false))
    }

    const onLogout = () => {
        logOutApi().finally(() => logOut())
    }

    return (
        <div className="ForgetPassword">
            <div className="ForgetPasswordForm">
                <div className="logoSection">
                    <h2 className="mb-0">Nutri Nexus</h2>
                </div>
                <Row justify="center">
                    <Col xs={24} md={16} xl={11} xxl={{ span: 7 }} className="rightForm">
                        <div id="ForgotPasswordFormContent" className="p-4 rounded">
                            <Result
                                status="info"
                                title="Please verify your email"
                                subTitle={<>
                                    We sent a verification link to <b>{email}</b>.
                                    Click the link in that email to start using Nutri Nexus.
                                    The link is valid for 24 hours.
                                </>}
                                extra={[
                                    <Button key="check" type="primary" loading={checking} onClick={checkAgain}>
                                        I've verified
                                    </Button>,
                                    <Button key="resend" loading={sending} onClick={resend}>
                                        Resend email
                                    </Button>,
                                    <Button key="logout" type="link" onClick={onLogout}>
                                        Logout
                                    </Button>,
                                ]}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}
